import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import loadRegistrationChallenge from './service/registrationChallenge';
import PasswordStrengthService from './service/PasswordStrengthService';
const signUpModalComponent = 'flarum/forum/components/SignUpModal';
const wait = milliseconds => new Promise(resolve => window.setTimeout(resolve, milliseconds));
app.initializers.add('devconnect-security-registration', () => {
  // Строковый путь поддерживает ленивую загрузку SignUpModal в Flarum 2 и не обращается к prototype до импорта компонента.
  extend(signUpModalComponent, 'oninit', function () {
    this.devconnectWebsite = '';
    this.devconnectChallenge = '';
    this.devconnectChallengeReadyAt = 0;
    this.devconnectPersonalDataConsent = false;
    this.devconnectPasswordStrength = new PasswordStrengthService();

    // Challenge загружается при открытии формы, чтобы не добавлять ожидание после нажатия кнопки регистрации.
    this.devconnectChallengePromise = loadRegistrationChallenge().then(token => {
      this.devconnectChallenge = token;
      this.devconnectChallengeReadyAt = Date.now() + 3100;
      return token;
    }).catch(() => '');
  });
  extend(signUpModalComponent, 'fields', function (items) {
    items.add('devconnect-website', m('.DevConnectHoneypot', {
      'aria-hidden': 'true'
    }, [m('label', {
      for: 'devconnect-website'
    }, 'Ваш сайт'), m('input#devconnect-website', {
      type: 'text',
      name: 'website',
      tabindex: '-1',
      autocomplete: 'off',
      value: this.devconnectWebsite,
      oninput: event => {
        this.devconnectWebsite = event.target.value;
      }
    })]), 5);
    items.add('devconnect-personal-data-consent', m('.Form-group.dc-registration-consent-group', [consentSwitch('devconnect-personal-data-consent', this.devconnectPersonalDataConsent, checked => {
      this.devconnectPersonalDataConsent = checked;
    }, ['Даю отдельное ', documentLink('/personal-data-consent', 'согласие на обработку персональных данных'), ' и подтверждаю, что ознакомился с ', documentLink('/privacy', 'политикой обработки данных'), '.']), m('p.dc-registration-terms', ['Нажимая «Регистрация», вы принимаете ', documentLink('/terms', 'пользовательское соглашение'), ' и ', documentLink('/rules', 'правила DevConnect'), '.'])]), 0);
    if (!this.attrs.token) {
      items.add('devconnect-password-strength', passwordStrengthIndicator(this.devconnectPasswordStrength.evaluate(this.password(), this.username(), this.email())), 9);
    }
  });
  extend(signUpModalComponent, 'submitData', function (data) {
    data.devconnectChallenge = this.devconnectChallenge;
    data.devconnectWebsite = this.devconnectWebsite;
    data.devconnectPersonalDataConsent = this.devconnectPersonalDataConsent;

    // Соглашение принимается самим действием регистрации, а отдельный переключатель
    // остаётся только у согласия на персональные данные и не объединяет разные документы.
    data.devconnectTermsAcceptance = true;
  });
  override(signUpModalComponent, 'onsubmit', async function (original, event) {
    event.preventDefault();
    if (this.loading) return;
    if (!this.devconnectPersonalDataConsent) {
      app.alerts.show({
        type: 'error'
      }, 'Для регистрации включите согласие на обработку персональных данных.');
      return;
    }
    this.loading = true;
    m.redraw();
    const token = this.devconnectChallenge || (await this.devconnectChallengePromise);
    if (!token) {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, 'Не удалось запустить защитную проверку. Закройте форму и попробуйте ещё раз.');
      m.redraw();
      return;
    }
    const remaining = Math.max(0, this.devconnectChallengeReadyAt - Date.now());
    if (remaining > 0) {
      await wait(remaining);
    }
    this.loading = false;
    return original(event);
  });
});
function consentSwitch(id, checked, update, label) {
  return m(`label.dc-registration-consent-switch[for=${id}]`, [m(`input#${id}`, {
    type: 'checkbox',
    required: true,
    checked,
    onchange: event => update(event.target.checked)
  }), m('span.dc-registration-consent-switch__control', {
    'aria-hidden': 'true'
  }, m('span')), m('span.dc-registration-consent-switch__label', label)]);
}
function documentLink(href, label) {
  return m('a', {
    href,
    target: '_blank',
    rel: 'noopener',
    onclick: event => event.stopPropagation()
  }, label);
}
function passwordStrengthIndicator(result) {
  return m('.dc-password-strength', {
    className: `is-level-${result.score}`
  }, [m('.dc-password-strength__heading', [m('span', 'Надёжность пароля'), m('strong', result.label)]), m('.dc-password-strength__meter', {
    role: 'meter',
    'aria-label': 'Надёжность пароля',
    'aria-valuemin': '0',
    'aria-valuemax': '100',
    'aria-valuenow': String(result.progress)
  }, m('span', {
    style: {
      width: `${result.progress}%`
    }
  })), m('p', result.hint)]);
}